import React from 'react';
import { Link } from 'react-router-dom';
import { ReceiptText, MessageCircle, ArrowUpRight, Shield, ShoppingBag } from 'lucide-react';
import PageHeading from '../components/PageHeading';

const services = [
  { Icon: ReceiptText, title: '免费领取 Invoice', description: '需要订单 Invoice，联系右下角客服免费领取。', to: '/after-sales/invoice', action: '查看领取说明' },
  { Icon: MessageCircle, title: '订单与售后咨询', description: '交付、激活或订阅遇到问题，提供订单号，由客服协助处理。', to: '/customer-service', action: '联系客服' },
];

export default function AfterSales() {
  return (
    <div className="page-shell">
      <PageHeading Icon={Shield} eyebrow="AFTER SALES · 售后服务" title="买完之后，也有大师兄" description="查交付、领 Invoice、处理订单问题，一处找到。" />
      <div className="grid md:grid-cols-2 gap-5">
        {services.map(({ Icon, title, description, to, action }) => (
          <article key={to} className="page-card flex flex-col items-start">
            <span className="page-icon mb-5"><Icon aria-hidden="true" /></span>
            <h2 className="text-xl font-bold mb-3">{title}</h2>
            <p className="text-sm text-muted mb-6 flex-1">{description}</p>
            <Link to={to} className="page-secondary">{action}<ArrowUpRight size={16} aria-hidden="true" /></Link>
          </article>
        ))}
      </div>
      <Link to="/orders" className="page-row mt-5"><ShoppingBag className="text-brand" /><div><strong>先找到你的订单</strong><p>在历史订单中查看订单号与交付内容。</p></div><ArrowUpRight size={20} /></Link>
    </div>
  );
}
